import React, { useState } from 'react'
import AdminAppBody from '../../../../components/admin/AdminAppBody';

const students = [
  {
    id: 1,
    name: "John Doe",
    mobile: "9876543210",
    email: "john@example.com",
    applyFor: "BBA",
    interested: "Marketing",
    date: "2025-06-01",
  },
  {
    id: 2,
    name: "Jane Smith",
    mobile: "9123456789",
    email: "jane@example.com",
    applyFor: "BCA",
    interested: "Web Development",
    date: "2025-06-02",
  },
  // Add more students here
];

const StudentRegisterList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterInterested, setFilterInterested] = useState("");

  const interests = Array.from(new Set(students.map(s => s.interested)));

  const filteredStudents = students.filter(student => {
    const search = searchTerm.toLowerCase();
    const matchesSearch =
      student.name.toLowerCase().includes(search) ||
      student.mobile.includes(searchTerm) ||
      student.email.toLowerCase().includes(search);

    const matchesInterested = filterInterested ? student.interested === filterInterested : true;

    return matchesSearch && matchesInterested;
  });

  return (
    <AdminAppBody
      content={
        <div className="container  card mt-4">
          <h2 className="mb-4 mt-2">Student Registration List</h2>

          <div className="row mb-3">
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Name, Mobile or Email"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-6">
              <select
                className="form-select"
                value={filterInterested}
                onChange={(e) => setFilterInterested(e.target.value)}
              >
                <option value="">Filter by Interested</option>
                {interests.map(interest => (
                  <option key={interest} value={interest}>{interest}</option>
                ))}
              </select>
            </div>
          </div>

          <table className="table table-bordered table-striped">
            <thead className="table-light">
              <tr>
                <th>Sr No</th>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th>Apply For</th>
                <th>Interested</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.length > 0 ? (
                filteredStudents.map((student, index) => (
                  <tr key={student.id}>
                    <td>{index + 1}</td>
                    <td>{student.name}</td>
                    <td>{student.mobile}</td>
                    <td>{student.email}</td>
                    <td>{student.applyFor}</td>
                    <td>{student.interested}</td>
                    <td>{student.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">No records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
    />
  );
}

export default StudentRegisterList;
